import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useRouteParam } from '@hooks/params';

import { corporateHealthQuoteFetch, CorporateHealthQuoteFetchPayload } from './action';
import { selectCorporateHealthQuoteBuy } from './selector';

export const useCorporateHealthQuoteFetch = () => {
  const dispatch = useDispatch();
  const orderNumber = useRouteParam('orderNumber') as string;
  const { corporateHealthQuote } = useSelector(selectCorporateHealthQuoteBuy);

  useEffectOnce(() => {
    const payload: CorporateHealthQuoteFetchPayload = { orderNumber };
    dispatch(corporateHealthQuoteFetch(payload));
  });

  return corporateHealthQuote;
};
